export const TEXTS = {
  BUTTON_EMAIL_TITLE: 'Электронной почты',
  BUTTON_PHONE_TITLE: 'Номера телефона',
  BUTTON_SBBID_TITLE: 'Войти по СберБизнес ID',
};
